

export const textcolors = {
  primary: "text-[#3b82f6]",
  secondary: "text-[#F3F3F5]",
  normaltext: "text-[#1C1C24]",
  success: "text-green-500",
  danger: "text-red-500",
  white: "text-white",
  dark: "text-[#2a2f45]",
  link: "text-[#0088FF]",
  muted: "text-gray-400",
  dim: "text-gray-500",
  warning: "text-yellow-600",
  placeholder: "placeholder-gray-400",
  inputPlaceholder: "placeholder:text-slate-400",
  accentHover: "hover:text-blue-600",
  hoverPrimary: "hover:text-blue-500",
  hoverDark: "hover:text-gray-800",
  hoverMuted: "hover:text-gray-600",
  hoverLink: "hover:text-[#0088FF]",
  hoverSlate: "hover:text-slate-600",
  hoverDanger: "hover:text-red-500",
  hoverDangerDark: "hover:text-red-600",
  hoverDangerDarker: "hover:text-red-700",
  slateBody: "text-slate-600",
  slateCaption: "text-slate-400",
  accentText: "text-blue-600",
  orange: "text-orange-500",
  orangeDark: "text-orange-600",
  successDark: "text-green-600",
  dangerDark: "text-red-600",
  dangerMuted: "text-red-400",
  dangerBadge: "text-red-800",
  warningBadge: "text-yellow-800",
  successBadge: "text-green-800",
  groupHoverWhite: "group-hover:text-white",
  groupHoverAccentDark: "group-hover:text-[#2563eb]",
  bodyMedium: "text-gray-600",
  warningText: "text-yellow-600",
  purpleDark: "text-purple-600",
  warningDark: "text-yellow-700",
  disabled: "text-gray-300",
  purple: "text-purple-500",
  indigo: "text-[#6366f1]",
};

export const bgcolors = {
  dark: "bg-[#1c1c24]",
  white: "bg-[#ffffff]",
  gray: "bg-[#ECECF0]",
  secondarygray: "bg-[#DDDDDDx]",
  primary: "bg-[#3b82f6]",
  primaryHover: "hover:bg-[#2563eb]",
  accentHover: "hover:bg-blue-50",
  accentHoverSubtle: "hover:bg-blue-50/30",
  accentLight: "bg-blue-50",
  hoverLight: "hover:bg-gray-100",
  overlay: "bg-black/40",
  modalOverlay: "bg-black/60",
  danger: "bg-red-500",
  dangerFaint: "bg-red-50",
  dangerHover: "hover:bg-red-50",
  success: "bg-green-500",
  successLight: "bg-green-50",
  successLighter: "bg-green-100",
  warningLight: "bg-yellow-100",
  dangerLight: "bg-red-100",
  purpleLight: "bg-purple-50",
  grayLight: "bg-gray-100",
  grayFaint: "bg-gray-50",
  grayAccent: "bg-gray-400",
  orangeLight: "bg-orange-50",
  orangeAccent: "bg-orange-400",
  disabledBg: "bg-gray-200",
  whiteOpaque: "bg-white/80",
  toggleInactive: "bg-gray-300",
  toggleDark: "bg-gray-600",
  toggleActive: "peer-checked:bg-green-500",
  toggleKnob: "after:bg-white peer-checked:after:border-white",
  backdropMid: "bg-black/50",
  backdropSubtle: "bg-slate-900/10",
  primaryFaint: "bg-[#3b82f6]/10",
  primaryGroupHover: "group-hover:bg-[#3b82f6]",
  successHover: "hover:bg-green-100",
  accentHoverStrong: "hover:bg-blue-100",
  hoverFaint: "hover:bg-gray-50",
  hoverMedium: "hover:bg-gray-200",
  secondary: "bg-[#3b82f6]",
  body: "bg-[#D9F3FD]",
  inputbg: "bg-[#F3F3F5]",
  surface: "bg-[#f6f8fc]",
  page: "bg-[#f8fafc]",
  tableHeader: "bg-gray-50",
  componentsclr:"bg-[#2a2f45]",
  groupHoverAccent: "group-hover:bg-[rgba(59,130,246,0.10)]",
  tableHeaderFaint: "bg-gray-50/80",
  warningFaint: "bg-yellow-50",
  primaryFaintOpacity: "bg-blue-500/10",
  successFaintOpacity: "bg-green-500/10",
};

export const borderstyles = {
  light: "border border-gray-200",
  divider: "divide-y divide-gray-100",
  tableHeader: "border-b border-gray-100",
  sidebar: "border-r border-[#DDDDDD]",
  separator: "border-t border-gray-100",
  focusRing: "focus:ring-1 focus:ring-blue-400",
  bottomLight: "border-b border-gray-200",
  checkboxBorder: "border-gray-500",
  focusSelect: "focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10",
  borderMedium: "border border-gray-300",
  hoverAccent: "hover:border-blue-400",
  focusWithinAccent: "focus-within:border-blue-500",
  peerFocusAccent: "peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-500",
  cardBorder: "border border-slate-200",
  accentSoft: "border border-blue-200",
  hoverAccentLight: "hover:border-blue-200",
  successBorder: "border border-green-200",
  orangeBorder: "border border-orange-200",
  dangerBorder: "border border-red-200",
  accentFaint: "border border-blue-100",
  accentBadge: "border border-blue-500/30",
  separatorMedium: "border-t border-gray-200",
  focusBlue: "focus:border-blue-500",
  inputError: "border-red-500",
  inputDefault: "border-gray-200 focus:border-blue-500",
  ringSuccess: "ring-2 ring-green-400",
  successFaint: "border border-green-100",
  successActive: "border-green-600",
  dangerActive: "border-red-600",
  hoverAccentStrong: "hover:border-blue-500",
  hoverGray: "hover:border-gray-300",
  groupHoverAccent: "group-hover:border-[rgba(59,130,246,0.30)]",
  purpleBorder: "border border-purple-200",
  warningBorder: "border border-yellow-200",
  successBorder: "border border-green-200",
  primaryBorder: "border-[#3b82f6]",
};

export const kpiAccents = {
  total:    { accent: "bg-yellow-400",  value: "text-yellow-500"  },
  active:   { accent: "bg-green-500",   value: "text-green-500"   },
  admins:   { accent: "bg-blue-500",    value: "text-blue-600"    },
  operator: { accent: "bg-purple-500",  value: "text-purple-600"  },
  viewers:  { accent: "bg-amber-400",   value: "text-amber-500"   },
};

export const textSizes = {
  h1: "text-4xl font-bold",
  h2: "text-3xl font-semibold",
  h3: "text-2xl font-medium",
  title1: "text-lg",
  title2: "text-xl font-bold ",
  subtitle: "text-sm",
  base: "text-base",
  extrasmall: "text-xs",
};

export const iconSizes = {
  sidebar: 20,
  action: 17,
  button: 18,
  info: 14,
  large: 24,
  dropdown: 15,
};

export const bordercolor = {
  borderline: "#C6C6C6"
}

export const fontWeights = {
  thin: "font-thin",
  light: "font-light",
  normal: "font-normal",
  medium: "font-medium",
  semibold: "font-semibold",
  bold: "font-bold",
  extrabold: "font-extrabold",
  black: "font-black",
};

/* Primary button uses --accent: #3b82f6 / --accent-hover: #2563eb */
export const buttons = {
  primary: "bg-[#3b82f6] hover:bg-[#2563eb] text-white font-semibold hover:-translate-y-0.5 transition-all shadow-sm",
  secondary: "bg-gray-100 text-gray-700 hover:bg-gray-200 font-medium transition-colors",
  danger: "bg-red-50 text-red-500 border border-red-200 font-bold hover:bg-red-100 transition-colors",
  success: "bg-green-500 hover:bg-green-600 text-white font-semibold transition-all",
};

export const colors = {
  text: "#1e293b",
  textDim: "#64748b",
  textMute: "#94a3b8",
  orange: "#f97316",
  danger: "#ef4444",
  dangerDark: "#dc2626",
  backdropDark: "rgba(0,0,0,0.65)",
  dangerSubtle: "rgba(239,68,68,0.06)",
  dangerBorder: "rgba(239,68,68,0.25)",
  dangerBg: "#fef2f2",
  dangerBorderLight: "#fecaca",
  accentSubtle: "rgba(59,130,246,0.06)",
  primaryFaint: "#3b82f608",
  primaryLight: "#3b82f612",
  primaryTag: "#3b82f615",
  primaryMid: "#3b82f620",
  accentDark: "#2563eb",
  accent: "#3b82f6",
  primary: "#3b82f6",
  primaryDark: "#2563eb",
  border: "#e2e8f0",
  border2: "#cbd5e1",
  bg: "#f8fafc",
  bg2: "#f1f5f9",
  panel: "#ffffff",
  surface: "#f6f8fc",
  overlay: "rgba(15,23,42,0.45)",
  successDark: "#16a34a",
  success: "#22c55e",
  warning: "#f59e0b",
  emerald: "#10b981",
  purple: "#a855f7",
  violet: "#8b5cf6",
  indigo: "#6366f1",
  wsConnectedBg: "#dcfce7",
  wsDisconnectedBg: "#fee2e2",
  emeraldFill: "rgba(16, 185, 129, 0.2)",
  primaryFill: "rgba(59, 130, 246, 0.2)",
  yellow: "yellow",
  yellowFaint: "rgba(255, 255, 0, 0.5)",
  yellowFill: "rgba(255, 255, 0, 0.2)",
  yellowFillFaint: "rgba(255, 255, 0, 0.1)",
  priorityHighBg: "#fff1f1",
  successFaintBg: "#f0fdf4",
  priorityMediumBg: "#fffbeb",
  priorityLowBg: "#eff6ff",
  chartBlue: "#3885CC",
  chartFade: "gray",
  accentHoverBg: "rgba(59,130,246,0.08)",
  accentBorderLight: "#bfdbfe",
  warningDark: "#d97706",
  accentHoverBorder: "rgba(59,130,246,0.30)",
  accentBorderSubtle: "rgba(59,130,246,0.22)",
  dangerHoverBg: "rgba(239,68,68,0.08)",
  dangerHoverBorder: "rgba(239,68,68,0.28)",
};

export const gradients = {
  accent: "linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)",
  accentSubtle: "rgba(59,130,246,0.10)",
  panel: "#ffffff",
  iconTile: "linear-gradient(135deg, rgba(59,130,246,0.14) 0%, rgba(99,102,241,0.10) 100%)",
  pageBg: "radial-gradient(ellipse at 0% 0%, rgba(59,130,246,0.06), transparent 50%), radial-gradient(ellipse at 100% 100%, rgba(236,72,153,0.05), transparent 50%)",
};

export const shadows = {
  button: "0 4px 14px -2px rgba(59,130,246,0.35)",
  buttonHover: "0 6px 20px -2px rgba(59,130,246,0.50)",
  card: "0 1px 4px 0 rgba(15,23,42,0.07)",
  cardHover: "0 8px 24px -4px rgba(15,23,42,0.13)",
  modal: "0 24px 64px -12px rgba(15,23,42,0.28)",
  healthModal: "0 24px 80px rgba(0,0,0,0.15)",
  authCard: "0 4px 24px 0 rgba(30,41,59,0.08)",
  tooltip: "0 4px 20px rgba(0,0,0,0.12)",
  dropdown: "0 8px 24px rgba(0,0,0,0.10)",
  focusRing: "0 0 0 4px rgba(59,130,246,0.13)",
  selectFocus: "0 0 0 3px rgba(59,130,246,0.1)",
  insetAccent: "inset 0 0 0 1px rgba(59,130,246,0.25)",
  menu: "0 8px 24px rgba(0,0,0,0.08)",
};
